import { useState } from "react";
import { Row, Form } from "react-bootstrap";
import moment from "moment";

import { StyledCardTeacher } from "../../styles/pages/AcademicActivityPlanStyles";
import {
    stylesBox,
    StyledCalendar,
    StyledInputGroupCalendar,
} from "../../styles/pages/GestaoFaltas/GestaoFaltas";
import CheckRadioStyles from "../../styles/components/CheckRadioStyles";
import {
    StyledInputGroupTextSearch,
    StyledFormControlSearch,
    StyledInputGroupSearch,
} from "../../styles/MainStyles";
import { CalendarIcon, SearchIcon } from "../../components/Icons";
import ButtonStyles from "../../styles/components/ButtonStyles";

import { useWorkflow } from "../../context/WorkflowContext";
import {
    IWorkflowFilter,
    IWorkflowType,
} from "../../context/interfaces/IWorkflowContext";
import { WorkflowTypeEnum } from "../../model/Enums/WorkflowTypeEnum";

type DateRange = [Date, Date];

const { BtnPrimary } = ButtonStyles;

const dateFormat = "YYYY-MM-DD";

const Filter = () => {
    const [dateRange, setDateRange] = useState<DateRange>([
        new Date(),
        new Date(),
    ]);

    const {
        workflowTypes,
        workflowFilter,
        filterWorkflows,
        setWorkflowFilter,
    } = useWorkflow();

    const WORKFLOW_WAITING_APPROVAL_NAME = "AGUARDANDO_APROVACAO";
    const WORKFLOW_APPROVED_NAME = "APROVADO,CANCELADO";

    const getTipoWorkflow = (workflowTypeId: number): string => {
        const index = workflowTypes.findIndex(
            (workflowType) =>
                workflowType.workflowId.toString() === workflowTypeId.toString()
        );

        if (index === -1) {
            return "Workflow desconhecido";
        }

        return workflowTypes[index].nome;
    };

    const handleChangeWorkflowType = (workflowTypeId: number) => {
        setDateRange([new Date(), new Date()]);
        const initialWorkflowFilter: IWorkflowFilter = {
            workflowTypeId,
            workflowTypeName: getTipoWorkflow(workflowTypeId),
            status: "AGUARDANDO_APROVACAO",
            searchName: "",
            initialDate: "",
            finalDate: "",
            actualPage: 0,
            pageSize: 10,
        };
        setWorkflowFilter(initialWorkflowFilter);
        filterWorkflows(initialWorkflowFilter);
    };

    const handleValidateDateRange = () => {
        return dateRange[0] && dateRange[1];
    };

    const handleChangeDate = () => {
        if (!handleValidateDateRange()) {
            setDateRange([dateRange[0], dateRange[0]]);
        }
    };

    const handleChangeSearchName = (string: string) => {
        setWorkflowFilter({
            ...workflowFilter,
            searchName: string,
        });
    };

    const handleChangeStatus = (status: string) => {
        let filter: IWorkflowFilter = {
            ...workflowFilter,
            status,
        };

        if (status === WORKFLOW_WAITING_APPROVAL_NAME) {
            filter = {
                ...filter,
                searchName: "",
                initialDate: "",
                finalDate: "",
            };
            setDateRange([new Date(), new Date()]);
            filterWorkflows(filter);
        }

        setWorkflowFilter(filter);
    };

    const isValid = handleValidateDateRange();

    const handleFilter = () => {
        const initialDateFormat = moment(dateRange[0]).format(dateFormat);
        const finalDateFormat = moment(dateRange[1]).format(dateFormat);

        const filter = {
            ...workflowFilter,
            actualPage: 0,
            initialDate: initialDateFormat,
            finalDate: finalDateFormat,
        };

        setWorkflowFilter(filter);
        filterWorkflows(filter);
    };

    const getWaitingApprovalData = () => {
        const filter = {
            ...workflowFilter,
            status: "AGUARDANDO_APROVACAO",
        };
        setWorkflowFilter(filter);
    };

    return (
        <>
            <Row className="align-items-center">
                <div style={stylesBox.box3}>
                    <StyledCardTeacher
                        style={{
                            marginRight: 20,
                            width: 200,
                            justifyContent: "center",
                        }}
                    >
                        Selecionar tipo de fluxo de aprovação
                    </StyledCardTeacher>
                    <Form.Select
                        style={{ width: 400 }}
                        onChange={(e: any) => {
                            handleChangeWorkflowType(e.target.value);
                        }}
                        defaultValue={-1}
                    >
                        <option value={-1} disabled>
                            Selecionar tipo de fluxo de aprovação
                        </option>
                        {workflowTypes
                            .filter(
                                (workflowType: IWorkflowType) =>
                                    workflowType.workflowId !==
                                    WorkflowTypeEnum.HoraExtra
                            )
                            .map((workflowType) => (
                                <option
                                    key={workflowType.workflowId}
                                    value={workflowType.workflowId}
                                >
                                    {workflowType.nome}
                                </option>
                            ))}
                    </Form.Select>
                </div>
            </Row>
            <Row style={stylesBox.box1}>
                <div style={stylesBox.box2}>
                    <StyledCardTeacher
                        style={{ marginRight: 20, marginTop: 20 }}
                    >
                        Filtrar
                    </StyledCardTeacher>
                    <CheckRadioStyles.StyledFormCheck
                        inline
                        label="Em andamento"
                        name="group1"
                        type="radio"
                        id="inline-1"
                        style={{ marginTop: 20 }}
                        checked={
                            workflowFilter.status ===
                            WORKFLOW_WAITING_APPROVAL_NAME
                        }
                        onChange={() => getWaitingApprovalData()}
                    />
                    <CheckRadioStyles.StyledFormCheck
                        inline
                        label="Concluído"
                        name="group1"
                        type="radio"
                        id="inline-2"
                        style={{ marginTop: 20 }}
                        checked={
                            workflowFilter.status === WORKFLOW_APPROVED_NAME
                        }
                        onChange={() =>
                            handleChangeStatus(WORKFLOW_APPROVED_NAME)
                        }
                    />
                    <div
                        style={{
                            width: 300,
                            marginTop: 13,
                        }}
                    >
                        <StyledInputGroupCalendar>
                            <StyledInputGroupTextSearch>
                                <CalendarIcon style={{ fill: "#787878" }} />
                            </StyledInputGroupTextSearch>
                            <StyledCalendar
                                selectionMode="range"
                                value={dateRange}
                                dateFormat="dd/mm/yy"
                                onHide={handleChangeDate}
                                onChange={(e) => {
                                    setDateRange(e.value as DateRange);
                                }}
                            />
                        </StyledInputGroupCalendar>
                    </div>
                    <div
                        style={{
                            width: 350,
                            marginTop: 13,
                        }}
                    >
                        <StyledInputGroupSearch>
                            <StyledInputGroupTextSearch>
                                <SearchIcon />
                            </StyledInputGroupTextSearch>
                            <StyledFormControlSearch
                                type="text"
                                placeholder="Pesquise por professor"
                                value={workflowFilter.searchName}
                                onChange={(e: any) =>
                                    handleChangeSearchName(e.target.value)
                                }
                            />
                        </StyledInputGroupSearch>
                    </div>
                    <div>
                        <BtnPrimary
                            style={{
                                width: 126,
                                marginLeft: 20,
                                marginTop: 10,
                            }}
                            onClick={() => handleFilter()}
                            disabled={!isValid}
                        >
                            Filtrar
                        </BtnPrimary>
                    </div>
                </div>
            </Row>
        </>
    );
};

export default Filter;
